// extracted by mini-css-extract-plugin
module.exports = {"informationBanner":"jgp-3-N0q","giftAidIcon":"jgp-937mu","closeIcon":"jgp-2VqH6"};